import styled from 'styled-components'

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 12px;
`

export const MessageBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 9px 15px;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background-color: #F7F7F7;
  }

  p {
    margin-bottom: 1px;
    width: auto;
  }
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`
